module.exports = __webpack_public_path__ + "img/meb-logo-red@2x.4dc25e9d.png";